import { render } from "./ToolBarComponent.vue?vue&type=template&id=16539544"
import script from "./ToolBarComponent.vue?vue&type=script&lang=js"
export * from "./ToolBarComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__